import React from 'react'
import { Link } from "react-router-dom";

function Header() {
  return (
    <div>
      <header>
        <input type="checkbox" id="menu-check" />
        <nav className="nav">
          {/* <a className="brand" href="../index.html">DMC</a> */}
          <div className="brand">
            <a href="/">
              <img className="brand-logo" src="/assets/images/logo/DMC-Logo.png" alt="DMCO" />
              <span className="brand-text">Drilling Materials Company</span>
            </a>
          </div> 

          {/* desktop links */}
          <div className="nav-links">
              <Link to="/about">About DMCO</Link>
              <Link to="/products">Products</Link>
              <Link to="/solutions">Solutions</Link>
              <Link to="/news">News</Link>
              <Link to="/about/sustainability">Sustainability</Link>
              {/* <Link to="/dashboard">Investors</Link> */}
              <Link to="/career">Careers</Link>
              <Link to="/contactUs">Contact</Link>

              {/* <a href="/about">About DMC <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2"/></svg></a>
              <a href="/products">Products</a>
              <a href="/solutions">Solutions</a>        
              <a href="/news">News</a>
              <a href="/about/sustainability">Sustainability</a>
              <a className="with-caret" href="/dashboard">Investors <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2"/></svg></a>
              <a className="with-caret" href="/career">Careers <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2"/></svg></a>
              <a href="/contactUs">Contact</a> */}
          </div>

          {/* <div className="nav-actions">
            <button aria-label="Search">🔍</button>
          </div> */}

          {/* mobile toggle */}
          <label for="menu-check" className="nav-toggle" aria-label="Open menu">
            <span className="bar"></span>
          </label>
        </nav>


        {/* mobile dropdown */}
        <div className="mobile-panel">
          <div className="mobile-links">
              <Link to="/about">About DMCO</Link>
              <Link to="/products">Products</Link>
              <Link to="/solutions">Solutions</Link>
              <Link to="/news">News</Link>
              <Link to="/about/sustainability">Sustainability</Link>
              {/* <Link to="/dashboard">Investors</Link> */}
              <Link to="/career">Careers</Link>
              <Link to="/contactUs">Contact</Link>
          </div>
        </div>
      </header>        
    </div>
  )
}

export default Header